import axios from 'axios';
import trackError from './track-error';
import app from '../main';
import store from '../store';
import appConfig from '../utils/config';

const axiosInstance = axios.create({
  baseURL: `${appConfig.API_BASE_URL}/`,
  withCredentials: true,
  headers: {
    jwtacc: localStorage.getItem('jwtacc') || '',
  },
});

axiosInstance.interceptors.request.use(
  config => config,
  error => {
    trackError(error);
    app.$bvToast.toast(error.message, {
      title: 'Ошибка',
      variant: 'danger',
      solid: true,
      autoHideDelay: 15000,
    });
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  async response => {
    // если в хедере есть jwtacc, логинимся и получаем юзера
    if (response.headers.jwtacc) {
      localStorage.setItem('jwtacc', response.headers.jwtacc);
      axiosInstance.defaults.headers.jwtacc = response.headers.jwtacc;

      if (response.data.refreshToken) {
        localStorage.setItem('refreshToken', response.data.refreshToken);
      }

      const user = await axiosInstance.get('users/1.0/self-user');
      store.commit('setUser', user);
    }
    return response.data;
  },
  async error => {
    trackError(error);

    if (!error.response) {
      return Promise.reject(error);
    }

    // редиректы на страницу авторизации
    if (
      error.response.status === 401 &&
                app.$route.name !== 'SignIn' &&
                app.$route.name !== 'EmailVerification' &&
                app.$route.name !== 'PasswordReset'
    ) {
      if (localStorage.getItem('jwtacc')) {
        store.commit('toggleSignOutModal', {
          isShown: true,
          text: 'Время сессии истекло, вы будете перенаправлены на страницу авторизации',
        });
        return;
      }
      app.$router.push('/sign-in');
    }

    // всплывашка с ошибками
    if (error.response.status !== 401) {
      const message = error.response.data && error.response.data.error ? error.response.data.error.message : error.message;

      app.$bvToast.toast(message, {
        title: 'Ошибка',
        variant: 'danger',
        solid: true,
        autoHideDelay: 15000,
      });
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
